import { apiFetch } from '@ami/react/core';

const _baseEndPoint = 'order-documents';

export default class CustomOrderDocument {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.orderId = item.orderId;
      this.fileUrl = item.fileUrl;
      this.fileKey = item.fileKey;
      this.lineItemId = item.lineItemId;
      this.serialNumbers = item.serialNumbers;
      this.isOtherType = item.isOtherType;
      this.fileName = item.fileName;
      return;
    }
    this.id = null;
    this.name = '';
    this.orderId = undefined;
    this.fileUrl = undefined;
    this.fileKey = undefined;
    this.lineItemId = null;
    this.serialNumbers = [];
    this.isOtherType = false;
  }

  static create(orderId, item) {
    return apiFetch(`${_baseEndPoint}/${orderId}`, 'POST', item);
  }

  static createShared(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/shared/${id}`, 'POST');
  }

  static delete(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/${id}`, 'DELETE');
  }

  static deleteShared(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/shared/${id}`, 'DELETE');
  }

  static getDownloadUrl(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/${id}`);
  }

  static getDownloadSharedUrl(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/shared/${id}`);
  }
}
